// extracted by mini-css-extract-plugin
module.exports = {"title":"PersonaTypeStep_title__1QLoc","buttons":"PersonaTypeStep_buttons__2tv0S","nextButton":"PersonaTypeStep_nextButton__2WpCL"};